import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[app-dynamic-sections]'
})
export class DynamicSectionsDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}


// WEBPACK FOOTER //
// ./src/app/forms/dynamic-sections.directive.ts